import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQuestionmarkCircle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconQuestionmarkCircle2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 7H15V10.9014L12.75 12.4014V14H11.25V11.5986L13.5 10.0986V8.5H10.5V10H9V7ZM12.75 15.5V17.01H11.25V15.5H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQuestionmarkCircle2;
